import { Html5QrcodeScanner } from "html5-qrcode";
import { useEffect } from "react";

const QRScanner = ({ onScan }) => {
  useEffect(() => {
    const scanner = new Html5QrcodeScanner("reader", { fps: 10, qrbox: 250 });

    scanner.render(
      (decodedText) => {
        onScan(decodedText);
        scanner.clear().catch((error) => {
          console.warn("Clear scanner error: ", error);
        });
      },
      (error) => {
        // Ignore scan errors
      }
    );

    return () => {
      scanner.clear().catch((error) => {
        console.warn("Clear scanner error (unmount): ", error);
      });
    };
  }, []);

  return (
    <div className="flex justify-center items-center w-full min-h-[400px]">
      <div
        id="reader"
        className="rounded-lg shadow-md"
        style={{ width: "100%" }}
      ></div>
    </div>
  );
};

export default QRScanner;
